import React from 'react';
import { ChatPage } from '../../chat/ChatPage';

export default function EnterpriseChatPage() {
  return <ChatPage />;
}
